import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[modify]'
})
export class ModifyDirective implements OnInit, OnDestroy {

  @Output()
  public modify = new EventEmitter<any>();
  private observer: MutationObserver;

  constructor(private ref: ElementRef) {
  }

  ngOnInit() {
    this.observer = new MutationObserver(() => this.modify.emit());
    this.observer.observe(this.ref.nativeElement, { subtree: true, characterData: true });
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
